import { List, ListItem, ListItemButton, Typography } from "@mui/material";

/**
 * スクロール可能なアイテムリストを表示するReactコンポーネントです。
 * 指定した高さとアイテムリストを受け取り、各アイテムをリストとして表示します。
 *
 * @param height リストの高さを指定します。CSSの高さ指定（例: '30vh', '200px' など）が利用できます。デフォルトは '30vh' です。
 *   例: '40vh'
 * @param itemList 表示するアイテムの配列です。各アイテムは label（表示名）と disable（無効化フラグ、任意）を持ちます。
 *   例: [{ label: 'アイテム1' }, { label: 'アイテム2', disable: true }]
 * @param disableMessage アイテムが無効化されている場合に表示するツールチップメッセージ（任意）。
 *   例: 'このデータは利用できません'
 */
export const ScrollableItemList: React.FC<{
    height?: string;
    itemList: {
        label: string;
        disable?: boolean;
    }[];
    disableMessage?: string;
}> = ({
    height = '30vh',
    itemList,
    disableMessage
}) => (
    <List
        sx={{
            height,
            overflowY: 'auto',
            bgcolor: '#EEEEEE',
            mx: '3vh',
            border: '1px solid #CCC',
            borderRadius: '8px',
            backgroundColor: '#FFFFFF'
        }}
    >
        {itemList.map((item, index) => (
            <ListItem key={index} disablePadding>
                <ListItemButton
                    title={item.disable ? disableMessage || 'このデータは利用できません' : item.label}
                    sx={{ cursor: 'pointer' }}
                >
                    <Typography
                        variant="subtitle1"
                        fontWeight="Regular"
                        sx={{
                            ml: '1vh',
                            color: item.disable ? '#AAA' : '#000',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%',
                            display: 'block'
                        }}
                    >
                        {item.label}
                    </Typography>
                </ListItemButton>
            </ListItem>
        ))}
    </List>
);